<template>
  <GroupForm v-if="isGroup" :folders="folders"></GroupForm>
  <FolderForm v-else-if="isFolder" :folders="folders"></FolderForm>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import GroupForm from '@/views/Users/Groups/layouts/Aside/components/GroupForm';
import FolderForm from '@/views/Users/Groups/layouts/Aside/components/FolderForm';

export default {
  components: { FolderForm, GroupForm },
  computed: {
    ...mapState('usersGroups', {
      storeGroup: s => s.aside.data.group,
      storeFolder: s => s.aside.data.folder,
      storeFolders: s => s.data.folders
    }),
    isGroup() {
      return Object.keys(this.storeGroup).length;
    },
    isFolder() {
      return Object.keys(this.storeFolder).length;
    },
    folders() {
      const folders = _.cloneDeep(this.storeFolders).map(item => {
        const obj = {};

        if (item.folder) {
          obj.folder = item.folder;
        }

        if (item.childrenFolders.length) {
          obj.childrenFolders = [...item.childrenFolders];
        }

        return obj;
      });

      folders.unshift({ folder: { name: 'Нет родителя', value: '' } });

      return folders;
    }
  }
};
</script>
